import AdminLayout from "../../../components/admin/layout/AdminLayout";
import GroupList from "../../../components/admin/group/GroupList";

function GroupListPage() {
  return (
    <AdminLayout>
      <GroupList />
    </AdminLayout>
  );
}

export default GroupListPage;
